import { useTranslate } from 'core/hooks/useTranslate';
import { MAIN_CONTENT_ID } from 'core/layout/constants';
import PdfViewerFullScreen from 'core/modules/components/pdfViewers/PdfViewerFullScreen/PdfViewerFullScreen';
import * as coreEntities from 'core/store/index';
import { PRIVACY } from 'edelvives/config/config';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { TextHtml } from 'ui';

const PrivacyPolicy = () => {
  const { t } = useTranslate();
  const language = useSelector((state) => coreEntities.i18n.selectors.getLanguage(state));
  const [showPdfViewer, setShowPdfViewer] = useState(false);

  let lang = language && Object.keys(PRIVACY).includes(language) ? language : 'es';

  useEffect(() => {
    let elements = document.getElementsByClassName('pprivacy');
    if (elements.length > 0) {
      document.getElementsByClassName('tyc_legal')[0].innerHTML = elements[0].innerHTML;
    }
    if (PRIVACY[lang] && PRIVACY[lang].endsWith('pdf')) {
      setShowPdfViewer(true);
    } else {
      setShowPdfViewer(false);
    }
  }, []);

  return (
    <main id={MAIN_CONTENT_ID} tabIndex={-1}>
      {showPdfViewer ? (
        <>
          <h1 className="sr-only">{t('login:Privacidad')}</h1>
          <PdfViewerFullScreen ariaLabel={t('login:Privacidad')} url={PRIVACY[lang]} />
        </>
      ) : (
        <div className="dialog-terms">
          <h1>{t('login:Privacidad')}</h1>
          <TextHtml text={PRIVACY[lang]} />
        </div>
      )}
    </main>
  );
};

export default PrivacyPolicy;
